import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        '.adyen-checkout__button': {
            backgroundColor: 'button.background.primary-default',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
        },
        '.adyen-checkout__payment-method--selected': {
            backgroundColor: 'background.default',
        },
        '.adyen-checkout__payment-method__name--selected': {
            textStyle: 'body-small',
            color: 'text.default',
            fontWeight: '400',
        },
        '.adyen-checkout__payment-method__image__wrapper:after': {
            border: 'unset',
        },
        '.adyen-checkout__payment-method__radio': {
            borderColor: 'border.dark',
        },
        '.adyen-checkout__payment-method__radio--selected': {
            background: 'background.dark',
        },
        '.adyen-checkout-form-instruction': {
            pt: remCalc(4),
            pb: remCalc(16),
            color: 'text.disable',
            textStyle: 'body-xsmall',
        },
        '.adyen-checkout__label__text': {
            pb: '0',
            textStyle: 'body-xsmall',
            color: 'text.default',
        },
        '.adyen-checkout__input-wrapper': {
            py: remCalc(8),
        },
        '.adyen-checkout__button adyen-checkout__button--pay': {
            mt: remCalc(16),
            mb: '0',
        },
        '.adyen-checkout__field adyen-checkout__card__holderName': {
            mt: '0',
        },
        '.adyen-checkout__checkbox': {
            display: 'flex',
            alignItems: 'center',
            width: 'fit-content',
        },
        '[id^=container-paywithgoogle]': {
            marginBottom: remCalc(20),
        },
    },
    variants: {
        disabled: {
            '.adyen-checkout__button': {
                bg: 'button.background.primary-disabled',
                color: 'button.text.primary-disabled',
                _hover: {
                    bg: 'button.background.primary-disabled !important',
                    color: 'button.text.primary-disabled',
                },
                pointerEvents: 'none',
            },
        },
        paymentMethods: {
            '.adyen-checkout__checkbox': {
                display: 'none',
            },
            'adyen-checkout__payment-method--klarna_account': {
                display: 'none',
            },
            '.adyen-checkout-form-instruction': {
                display: 'none',
            },
            '.adyen-checkout__button adyen-checkout__button--pay': {
                w: '100%',
            },
        },
    },
}
